import {Stack} from "expo-router";
import WebHeader from "@/lib/components/WebHeader";
import {Platform} from "react-native";
import GroupHeader from "@/lib/components/GroupHeader";

export const unstable_settings = {
    initialRouteName: 'index',
};

export default function StackLayout() {
    return (
        <Stack
            initialRouteName={"index"}
            screenOptions={{
                header: Platform.OS === "web" ? WebHeader : undefined,
                headerBackButtonDisplayMode: "minimal",
            }}
        >
            <Stack.Screen name="index" options={{title: "Samfunn"}}/>
            <Stack.Screen name="search" options={{title: "Søk i samfunn"}}/>
            <Stack.Screen name="[group_id]/index" options={{title: "Samfunn", headerRight: GroupHeader}}/>
            <Stack.Screen name="[group_id]/share" options={{title: "Del samfunn"}}/>
            <Stack.Screen name="[group_id]/edit" options={{title: "Rediger samfunn"}}/>
            <Stack.Screen name="[group_id]/banner" options={{title: "Velg banner"}}/>
            <Stack.Screen name="[group_id]/participants/index" options={{title: "Medlemmer"}}/>
            <Stack.Screen name="[group_id]/participants/[username]/index" options={{title: "Rolle"}}/>
            <Stack.Screen name="[group_id]/invite" options={{title: "Inviter"}}/>
            <Stack.Screen name="create" options={{title: "Nytt samfunn"}}/>
        </Stack>
    );
}